export const thousandUnitValue = (value: number) =>
  typeof value === 'number' && value === Number(value) ? Math.round(value / 1000) : 0;
